import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Col } from "react-bootstrap";

import ConditionalButton from "../../../layout/conditional-button";
import Table from "../../../layout/table";
import { canManageFeradelAdministration, canViewFeradelAdministration } from "../../../constants/permissions";
import { sourceList } from "../../../actions/products";
import { currency as formatCurrency } from "../../../utils/number";
import { formatFrequencyCode } from "../../product/utils";

class Products extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            size: 25,
            search: "",
            order: "name",
            index: 0,
            direction: "ASC",
            data: [],
            pages: 0
        };
    }

    componentDidMount = () => {
        this.fetchData();
    }

    componentDidUpdate = (oldProps) => {
        const oldPermissions = (oldProps.auth?.permissions || []).join("|");
        const newPermissions = (this.props.auth?.permissions || []).join("|");
        if (oldPermissions !== newPermissions && this.canViewProducts && this.state.data.length === 0) {
            this.fetchData();
        }
    }

    get canViewProducts() {
        return canViewFeradelAdministration(this.props.auth?.permissions);
    }

    get canManageProducts() {
        return canManageFeradelAdministration(this.props.auth?.permissions);
    }

    get headers() {
        return [
            {
                header: "Name",
                sortable: true,
                source: "name",
                className: "text-muted text-small text-uppercase w-20",
                onFormat: this.onLinkFormat
            },
            {
                header: "Caption",
                sortable: true,
                source: "caption",
                className: "text-muted text-small text-uppercase w-25",
                onFormat: this.onLinkFormat
            },
            {
                header: "Category",
                sortable: true,
                source: "category",
                className: "text-muted text-small text-uppercase w-20"
            },
            {
                header: "Price",
                sortable: true,
                source: "price",
                className: "text-muted text-small text-uppercase w-15 text-end",
                onFormat: this.onPriceFormat
            },
            {
                header: "Frequency",
                sortable: true,
                source: "frequency",
                className: "text-muted text-small text-uppercase w-10",
                onFormat: this.onFrequencyFormat
            },
            {
                header: "Visibility",
                sortable: true,
                source: "visibility",
                className: "text-muted text-small text-uppercase w-10 text-end"
            }
        ];
    }

    fetchData = async () => {
        if (!this.canViewProducts) return;

        const result = await this.props.sourceList({
            page: this.state.page,
            size: this.state.size,
            order: this.state.order,
            direction: this.state.direction,
            raw: 1,
            search: this.state.search
        });
        const data = result?.rows || [];
        const pages = data.length > 0 ? Math.ceil(Number(result.count || 0) / Number(this.state.size)) : 0;

        this.setState({
            data,
            pages
        });
    }

    onPriceFormat = (e) => formatCurrency(Number(e));

    onFrequencyFormat = (e) => formatFrequencyCode(e?.toString());

    onLinkFormat = (e, row) => {
        return `<a href="/dashboard/settings/products/${row["uuid"]}">${e || ""}</a>`;
    }

    onColumnClick = (e) => {
        const headers = this.headers;
        const index = headers.findIndex((item) => item.header === e.header && item.source === e.source);

        this.setState({
            index,
            direction: this.state.index === index && this.state.direction === "DESC" ? "ASC" : "DESC",
            order: headers[index].source,
            page: 0
        }, this.fetchData);
    }

    onSearch = (e) => {
        this.setState({
            search: e,
            page: 0
        }, this.fetchData);
    }

    onSize = (e) => {
        this.setState({
            page: 0,
            size: Number(e)
        }, this.fetchData);
    }

    onPageChange = (e) => {
        this.setState({
            page: Number(e)
        }, this.fetchData);
    }

    onNewClick = () => {
        if (this.canManageProducts) window.location.href = "/dashboard/settings/products/add";
    }

    render() {
        if (!this.canViewProducts) {
            return <Col xs="12">Product settings not available.</Col>;
        }

        return (
            <>
                <Col md="8" className="float-right text-end">
                    <ConditionalButton enabledVariant="outline-primary" tooltip="Create new product" display={this.canManageProducts} enabled={this.canManageProducts} onEnabledClick={this.onNewClick} icon="flash">New</ConditionalButton>
                </Col>
                <Col xs="12">
                    <Table
                        headers={this.headers}
                        page={this.state.data}
                        sort={{ index: this.state.index, direction: this.state.direction }}
                        size={this.state.size}
                        index={this.state.page}
                        pages={this.state.pages}
                        onColumnClick={this.onColumnClick}
                        onPageChange={this.onPageChange}
                        onSearch={this.onSearch}
                        onSize={this.onSize}
                        searchable
                        sizable
                    />
                </Col>
            </>
        );
    }
}

Products.propTypes = {
    auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateToProps, { sourceList })(Products);
